"use client"
import { ApiResponseV2, ErrorResponse, QuoteRequest } from "@vertical-insure/shared";
import { omit } from "lodash-es";

const API_URL = process.env.NEXT_PUBLIC_API_URL;

export type QuoteFunctionV2 = (
  clientId: string,
  version: string,
  product: string,
  embeddedPayments: boolean,
  request: QuoteRequest
) => Promise<ApiResponseV2 | ErrorResponse>;

export const quote: QuoteFunctionV2 = async (
  clientId: string,
  version: string,
  product: string,
  embeddedPayments: boolean,
  request: QuoteRequest
): Promise<ApiResponseV2 | ErrorResponse> => {

  const res = await fetch(`${API_URL}/v2/quote/${product}`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "x-api-client-id": clientId,
      "x-api-source": "Offer Element",
      "x-api-web-component-version": version,
      ... embeddedPayments ? {
        "x-api-options": "embedded-payments"
      } : {}
    },
    body: JSON.stringify(request)
  });

  const data = await res.json();

  if (res.ok) {
    return data as ApiResponseV2;

  } else if (res.status === 422 || res.status === 404) {
    // if we get a 422, or a 404 it means the quote id or offer_id are invalid, so we are going to reset them and try again
    const requestNoId = omit(request, ["quote_id", "offer_id"]);
    return quote(clientId, version, product, embeddedPayments, requestNoId);

  } else {
    // TODO This will be different
    if (!data?._embedded) {
      // if we have an error that we potentially want to display (e.g. activity_not_available or state_not_available)
      return {
        error: data.message,
        error_code: data.error_code
      }
    } else {
      // errors we will ignore and no quote will be created; typically because of bad or missing data
      const message = data._embedded.errors[0]?.message;

      return {
        error: message,
        error_code: 'bad_request'
      }
    }
  }
}
